import { render } from "./MediaKindsTable.vue?vue&type=template&id=2c0dabb8"
import script from "./MediaKindsTable.vue?vue&type=script&lang=js"
export * from "./MediaKindsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__